"use strict";

import React, {useContext, useEffect, useState} from 'react';
import AccountEchecksCreateAuthorizeForm from "./AccountEchecksCreateAuthorizeForm";
import axios from "../utilities/axiosEcheckWrapper";

const AccountEchecksCreateAuthorize = ({
       stepsHeaderOffsetTop= 0,
       financialAccountData={},
       authorizeData={},
       onSubmit=()=>{},
}) => {
    const [isFetchingFinancialInstitutionReport, setIsFetchingFinancialInstitutionReport] = useState(false);
    const [financialInstitutionReport, setFinancialInstitutionReport] = useState({});

    useEffect(()=>{
        const {
            bank_routing_number='',
            bank_account_number='',
        } = financialAccountData;

        setIsFetchingFinancialInstitutionReport(()=>{
            return true;
        });

        axios.post(`echecks/financial-links/institutions/report`, {
            bank_routing_number: bank_routing_number,
            bank_account_number: bank_account_number,
        })
        .then((response)=>{
            setFinancialInstitutionReport(()=>{
                return {...response.data};
            });
        })
        .catch((error)=>{
            return false;
        }).finally(()=> {
            setIsFetchingFinancialInstitutionReport(() => {
                return false;
            });
        });
    }, [financialAccountData]);

    return (
        <div style={{position: 'relative',}}>
            {isFetchingFinancialInstitutionReport &&
                <div style={{position: 'relative',}}>
                    Getting bank information...
                    <div className="loading loading--cover loading--center-flex loading--w-flip" />
                </div>
                ||
                <AccountEchecksCreateAuthorizeForm
                    stepsHeaderOffsetTop={stepsHeaderOffsetTop}
                    financialAccountData={financialAccountData}
                    financialInstitutionReport={financialInstitutionReport}
                    onSubmit={onSubmit} />
            }
        </div>
    );
}

export default AccountEchecksCreateAuthorize;
